import React from 'react';
import Img from "gatsby-image";
import '../../sass/components/_product.scss';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import ProductSelector from './ProductSelector'
import Sizetable from './Sizetable'

class Product extends React.Component {

  constructor(props) {
    super(props);
  }

  render(){

    let sizesByGender = {
    }

    let sizeData = this.props.stock ? this.props.stock : this.props.sizes;
    
    let multipleSizes = false;

    sizeData.data.map(function(sizeData, key) {
      if (!(sizeData.sex in sizesByGender)){
        sizesByGender[sizeData.sex] = [];
      }
      sizesByGender[sizeData.sex].push(sizeData);
      multipleSizes = key > 0;
    })

    return(
      <div className="product">
        <Img alt={this.props.title} className="image" resolutions={this.props.image.resolutions}/>
        <div className="text">
          <h2>{this.props.title}</h2>
          <p dangerouslySetInnerHTML={{__html: this.props.description}} />
          <p>more pictures on instagram: <OutboundLink href={`https://www.instagram.com/explore/tags/${this.props.instagramHashtag.replace('#','')}`} target="_blank">#{this.props.instagramHashtag.replace('#','')}</OutboundLink></p>
          {multipleSizes && <Sizetable />}
          <p className="price"><span className="currency">€</span> <span className="amount">{Number.parseFloat(this.props.price).toFixed(2).replace('€','')}</span> excl. shipping</p>
          <ProductSelector
            product={this.props.product}
            productId={this.props.productId}
            sizes={this.props.stock}
            stock={sizesByGender}
          />
        </div>
      </div>
    )
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js